import { render, staticRenderFns } from "./CMRegister.vue?vue&type=template&id=13e1b135&scoped=true&"
import script from "./CMRegister.vue?vue&type=script&lang=js&"
export * from "./CMRegister.vue?vue&type=script&lang=js&"
import style0 from "./CMRegister.vue?vue&type=style&index=0&id=13e1b135&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e1b135",
  null
  
)

export default component.exports